import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";
import * as globalConst from './../../../constants';
import { Subject } from "rxjs/Rx";

@Injectable()
export class EconomicGroupService {

  private apiUrl = globalConst.baseAPI;  // URL para web api
  groupsChanged = new Subject();

  constructor(private http: Http) { }

  getEconomicGroups(userID) {
    console.log(userID);
    return this.http
      .get(this.apiUrl + "/economicgroup/v1/getcodclient/" + userID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getGroupLog(userID, orderby, sort, page) {
    page = page * globalConst.paginationSkip;
    return this.http
      .get(this.apiUrl + "/logs/v1/logseconomicgroup/" + userID + "?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getGroupMembers(groupID) {
    var params = {
      GrupoId: groupID
    };

    return this.http
      .post(this.apiUrl + "/groupsmembers/v1/postgroupsdetails/", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  checkEconomicGroupName(groupName) {
    return this.http
      .get(this.apiUrl + "/economicgroup/v1/getgroupbyname/name=" + groupName, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  // findMemberByDoc(memberDoc){
  //   return this.http
  //   .get(this.apiUrl + "/economicgroup/v1/getgroupbyname/"+memberDoc, JSON.parse(localStorage.getItem('yara.connectionHeader')))
  //   .map((res: Response) => res.json()).catch(e => {
  //     if (e.status === 401) {
  //       return Observable.throw('Unauthorized');
  //     }
  //   });
  // }

  insertGroupMember(members) {
    return this.http
      .post(this.apiUrl + "/groupsmembers/v1/insertmembers", members, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  updateGroupExplosion(member) {
    return this.http
      .put(`${this.apiUrl}/groupsmembers/v1/putgroupexplosion/`, member, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getAccountClientByDoc(doc) {
    var params = {
      CodigoPrincipal: null,
      Nome: null,
      Documento: doc,
      Apelido: null,
      GrupoEconomico: null,
    };
    return this.http
      .post(this.apiUrl + "/accounts/v1/searchcustomer", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getAccountClientByCod(cod) {
    var params = {
      CodigoPrincipal: cod,
      Nome: null,
      Documento: null,
      Apelido: null,
      GrupoEconomico: null,
    };
    return this.http
      .post(this.apiUrl + "/accounts/v1/searchcustomer", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  insertEconomicGroup(newGroup) {
    return this.http
      .post(this.apiUrl + "economicgroup/v1/inserteconomicgroup", newGroup, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getRelations(classificationID) {
    return this.http
      .get(this.apiUrl + "relationshiptypegroup/v1/getrelationshiptypegroupbyclassificationid/" + classificationID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getFinancialDetail(userCode) {
    return this.http
      .get(this.apiUrl + "financialaccounts/v1/getfinancialcode/" + userCode, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });

  }

  removeMember(memberList) {
    return this.http
      .post(this.apiUrl + "groupsmembers/v1/inactivemembers", memberList, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  removeGroup(groupID, userID) {
    return this.http
      .delete(this.apiUrl + "economicgroup/v1/requestdeleteeconomicgroup/" + groupID + "/" + userID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/economic-group/service/economic-group.service.ts